export default __webpack_public_path__ + "static/media/Quiken_Expertos_Cumplimiento-13.c13595d3.svg";